let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("5qZQG")).then(() => parcelRequire('2lN8c'));